import { Badge } from '@shared/ui/Badge';
import { Card } from '@shared/ui/Card';
import { IconChevronDown, IconChevronRight } from '@shared/ui/icons';
import { Notes, SectionHead, Toggle } from '../styles';

export function NotesCard({
  notes,
  notesOpen,
  onToggleNotesOpen,
}: {
  notes: string[];
  notesOpen: boolean;
  onToggleNotesOpen: () => void;
}) {
  return (
    <Card>
      <SectionHead>
        <Toggle type="button" aria-expanded={notesOpen} onClick={onToggleNotesOpen}>
          {notesOpen ? <IconChevronDown size={16} /> : <IconChevronRight size={16} />}
          Пояснения к ведомости <Badge $tone="neutral">{notes.length}</Badge>
        </Toggle>
      </SectionHead>
      {notesOpen && (
        <Notes>
          {notes.map((n, i) => (
            <li key={i}>{n}</li>
          ))}
        </Notes>
      )}
    </Card>
  );
}
